import apiService from './apiService';
import { API_ENDPOINTS } from '../constants/apiConstants';

export const bannerAPI = {
  getAllBanners: async (params: { page?: number; limit?: number; search?: string }) => {
    const response = await apiService.get(API_ENDPOINTS.BANNER.GET_ALL, { params });
    return response.data;
  },
  getBannerById: async (id: string) => {
    const response = await apiService.get(`${API_ENDPOINTS.BANNER.GET_BY_ID}/${id}`);
    return response.data;
  },
  createBanner: async (formData: FormData) => {
    const response = await apiService.uploadFile(API_ENDPOINTS.BANNER.CREATE, formData);
    return response.data;
  },
  updateBanner: async (id: string, formData: FormData) => {
    const response = await apiService.uploadFilePut(`${API_ENDPOINTS.BANNER.UPDATE}/${id}`, formData);
    return response.data;
  },
  deleteBanner: async (id: string) => {
    const response = await apiService.delete(`${API_ENDPOINTS.BANNER.DELETE}/${id}`);
    return response.data;
  },
};